import React, { Component } from 'react'
import { connect } from 'react-redux'

import Paper from 'material-ui/Paper'

import { doc, dirtyRead } from 'selectors/common'
import { totalIncome } from 'selectors/application'

let select = dirtyRead(
	(state, props) => ({
		application: doc(state, props.applicationID)
	  , totalIncome: totalIncome(state, props.applicationID)
	})
)

export class MainInfo extends Component{
	render(){
		let { props } = this
		let additionalInfo = props.application.primaryResident.additionalInfo
		return(
			<Paper
				style={{
					backgroundColor: "#fff"
				  , display: "inline-block"
				  , width: "100%"
				  , padding: "15px"
				  , marginBottom: "10px"
				}}
			>
				<div style={{display: "flex", justifyContent: "space-around"}}>
					<p style={{margin: "0", color: additionalInfo.bankrut? "red" : "green"}}>{additionalInfo.bankrut? "Bankruptcy" : "No bankruptcy"}</p>
					<p style={{margin: "0", color: additionalInfo.crime? "red" : "green"}}>{additionalInfo.crime? "Crime" : "No crime"}</p>
					<p style={{margin: "0", color: additionalInfo.eviction? "red" : "green"}}>{additionalInfo.eviction? "Eviction" : "No eviction"}</p>
					<p style={{margin: "0"}}>Total income: $ {props.totalIncome}</p>
				</div>
			</Paper>
		)
	}
}

export default connect(select)(MainInfo)



// WEBPACK FOOTER //
// ./src/routes/landlord/applicationForm/MainInfo.js